import { Children, cloneElement, isValidElement, useId } from "react";

import type { ReactNode } from "react";
import type { RadioChangeEvent, RadioProps } from "./Radio";

export interface RadioGroupChangeEvent {
  value: string;
}

export interface RadioGroupProps {
  children?: ReactNode;
  name?: string;
  value?: string;
  onChange?: (event: RadioGroupChangeEvent) => void;
}

export function RadioGroup({
  children,
  name,
  value,
  onChange,
}: RadioGroupProps) {
  const _name = useId();

  const renderChildren = () => {
    function handleChange(e: RadioChangeEvent) {
      onChange?.({ value: e.value });
    }

    return Children.map(
      children,
      (child) =>
        isValidElement(child) &&
        cloneElement(child, {
          checked: value === child.props.value,
          name: name ?? _name,
          onChange: handleChange,
        } as Partial<RadioProps>),
    );
  };

  return (
    <div className={"RadioGroup"} role="radiogroup">
      {renderChildren()}
    </div>
  );
}
